import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { PracticeService } from '../../data/service/practice.service';

/**
 * SD-1248: the practice pages (/clients and below) are for members of an advisor practice.
 * Anyone else goes to Home.
 *
 * A route can ask for more with `data: { practiceRole: 'manager' }` (the Team page): then at least
 * one of the user's practices must have them as a manager, or they go back to /clients. The page
 * still checks the practice it is showing, and the server checks every call.
 */
@Injectable({ providedIn: 'root' })
export class PracticeGuard implements CanActivate, CanActivateChild {

  constructor(private practice: PracticeService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.check(route);
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    return this.check(childRoute);
  }

  private check(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const role = route && route.data ? route.data.practiceRole : undefined;
    return this.practice.me$.pipe(
      take(1),
      map(me => {
        if (me.practices.length === 0) {
          return this.router.createUrlTree(['/dashboard']);
        }
        if (role && !me.practices.some(p => p.role === role)) {
          return this.router.createUrlTree(['/clients']);
        }
        return true;
      })
    );
  }
}
